import {useState} from 'react';
import {StorageObject} from '../models/StorageObject';
import {useMutation, useQueryClient} from 'react-query';
import {STORAGE_OBJECTS_QUERY_KEY} from '../init/constants';
import {APIClient} from '../backend/ApiClient';
import {EditFolderDTO} from '../models/dto/EditFolderDTO';

export const useEditFolder = () => {
    const queryClient = useQueryClient();
    const apiClient = APIClient();

    const [folderToEdit, setFolderToEdit] = useState<StorageObject | null>(null);

    const editFolderApiCall = (editFolderDTO: EditFolderDTO) => {
        return apiClient.updateFolder(editFolderDTO.item);
    };

    const {mutateAsync: editFolderMutation, isLoading} = useMutation(editFolderApiCall, {
        onSuccess: () => {
            queryClient.invalidateQueries(STORAGE_OBJECTS_QUERY_KEY);
            setFolderToEdit(null);
        }
    });

    const editFolder = (editFolderDTO: EditFolderDTO) => {
        return editFolderMutation(editFolderDTO);
    };

    return {folderToEdit, setFolderToEdit, editFolder, isLoading};
};
